// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AM5T","right":"styles_right__2GiYl"};